import { Component } from '@angular/core';
import { OrganizationProviderService } from './service/providers/organization-provider.service';
import { TranslateService } from '../../node_modules/@ngx-translate/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  en = true;
  constructor(private translate: TranslateService) {
    const year = new Date().getFullYear();
    document.title += ` ${year}`;
    try {
      this.en = JSON.parse(localStorage.getItem('en'));
    } catch (error) { }
    if (this.en === null) {
      this.en = true;
    }
    localStorage.setItem('en', JSON.stringify(this.en));
    translate.setDefaultLang(this.en ? 'en' : 'fr');
  }
}
